module.exports = __webpack_public_path__ + "static/media/sgf.fd337411.png";